import { Component, Input, OnInit } from '@angular/core';
import { ICardHeaderCounter, ICardHeaderSectionDefault } from '@shared/components/card/card-header/card-header.model';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-card-header-section',
  templateUrl: './card-header-section.component.html',
  styleUrls: ['./card-header-section.component.scss'],
})
export class CardHeaderSectionComponent implements OnInit {
  @Input() data: BehaviorSubject<ICardHeaderCounter[]>;
  @Input() dataSectionDefault: BehaviorSubject<ICardHeaderSectionDefault[]>;
  @Input() title: string = '';
  isData: boolean = false;
  isDataSection: boolean = false;

  isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor() {}

  ngOnInit(): void {
    if (this.data) {
      this.data.subscribe((res) => {
        this.isLoading.next(!(res && res.length));
      });
    }
    if (this.dataSectionDefault)
      this.dataSectionDefault.subscribe((res) => {
        this.isLoading.next(!(res && res.length));
      });
  }
}
